import Vue from 'vue';
import App from './App.vue';
import Vant, { Locale as VantLocale } from 'vant';
import vantZhCN from 'vant/lib/locale/lang/zh-CN';
import vantJaJP from 'vant/lib/locale/lang/ja-JP';
import vantEnUS from 'vant/lib/locale/lang/en-US';
import 'vant/lib/index.css';
import router from './router';
import http from './http';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import common from './common/function'
import 'swiper/swiper-bundle.css'
import store from './store'
import i18n from './locales'
import PublicTextI18n from './common/publicTextI18n'
import CurrencyDisplay from './common/currencyDisplay'

import 'video.js/dist/video-js.css'


//

Vue.prototype.$http = http
Vue.prototype.common = common
Vue.config.productionTip = false
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
Vue.use(Vant);
Vue.use(PublicTextI18n);
Vue.use(CurrencyDisplay);
const vantLanguages = {
  'zh-CN': vantZhCN,
  'ja-JP': vantJaJP,
  'en-US': vantEnUS
};

function syncVantLanguage(locale) {
  const selected = Object.prototype.hasOwnProperty.call(vantLanguages, locale)
    ? locale
    : 'zh-CN';

  VantLocale.use(selected, vantLanguages[selected]);
}

syncVantLanguage(i18n.locale);

new Vue({
  i18n,
  store,
  router,
  created() {
    this.$watch(
      () => this.$i18n.locale,
      locale => syncVantLanguage(locale)
    );
  },
  render: h => h(App),
}).$mount('#app');
